import { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { ArrowLeft, MailCheck } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email, origin: window.location.origin });
      setSent(true);
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="relative flex min-h-screen items-center justify-center overflow-hidden bg-[#0b0d10] px-4 py-10">
      <img src="/login-lux-bg.jpg" alt="" aria-hidden="true" className="absolute inset-0 h-full w-full object-cover" />
      <div className="absolute inset-0 bg-gradient-to-b from-[#0b0d10]/80 via-[#0b0d10]/70 to-[#0b0d10]/90" />
      <div
        data-testid="forgot-card"
        className="relative z-10 w-full max-w-md rounded-[28px] border border-white/60 bg-white/95 p-8 shadow-[0_30px_80px_-20px_rgba(0,0,0,0.6)] backdrop-blur-2xl sm:p-11"
      >
        <div className="flex flex-col items-center text-center">
          <div className="mb-6 rounded-2xl bg-white px-6 py-4 shadow-sm ring-1 ring-slate-100">
            <img src="/clazing-logo.png" alt="Clazing Convenience Food" className="h-16 w-auto object-contain" onError={(e) => { e.currentTarget.style.display = "none"; }} />
          </div>
          <h1 className="font-display text-2xl font-semibold tracking-tight text-slate-900">Wachtwoord vergeten</h1>
          <p className="mt-2 text-sm text-slate-500">Vul je e-mailadres in. We sturen je een link om een nieuw wachtwoord in te stellen.</p>
        </div>

        {sent ? (
          <div data-testid="forgot-success" className="mt-7 rounded-xl border border-emerald-200 bg-emerald-50 px-4 py-4 text-sm text-emerald-800">
            <div className="mb-1 flex items-center gap-2 font-semibold"><MailCheck className="h-4 w-4" /> Controleer je e-mail</div>
            Als dit e-mailadres bij ons bekend is, is er een herstel-link verstuurd. De link is 1 uur geldig.
          </div>
        ) : (
          <>
            {error && (
              <div className="mt-6 rounded-xl border border-rose-200 bg-rose-50 px-4 py-3 text-sm text-rose-700" data-testid="forgot-error">{error}</div>
            )}
            <form onSubmit={submit} className="mt-7 space-y-5">
              <div>
                <Label className="text-xs font-semibold uppercase tracking-wider text-slate-500">E-mailadres</Label>
                <Input
                  data-testid="forgot-email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="naam@clazing.nl"
                  className="mt-1.5 h-11 rounded-xl border-slate-200 bg-slate-50/60"
                  required
                />
              </div>
              <Button data-testid="forgot-submit" type="submit" disabled={loading} className="h-12 w-full rounded-xl bg-slate-900 text-[15px] font-semibold text-white hover:bg-slate-800">
                {loading ? "Bezig..." : "Stuur herstel-link"}
              </Button>
            </form>
          </>
        )}

        <Link to="/login" data-testid="forgot-back" className="mt-7 flex items-center justify-center gap-2 text-xs font-medium text-slate-500 hover:text-slate-800">
          <ArrowLeft className="h-3.5 w-3.5" /> Terug naar inloggen
        </Link>
      </div>
    </div>
  );
}
